export default __webpack_public_path__ + "static/media/chevron-right.a4d25cf4.svg";